@if (eventable$ | async; as eventable) {
  <pr-timeline-tooltip [eventable]="eventable" />
}
